(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2047],{

/***/ 44798:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/salary-calculator",
      function () {
        return __webpack_require__(40063);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 40063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ salary_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Tools/SalaryCalculator/Category.jsx


const Category = (param)=>{
    let { name , unadjusted , adjusted  } = param;
    const adjustedSalary = ()=>{
        if (adjusted) {
            adjusted = parseFloat(adjusted).toFixed(2);
            adjusted = parseFloat(adjusted).toLocaleString("en-US");
            return adjusted;
        }
        return "$";
    };
    const unadjustedSalary = ()=>{
        if (unadjusted) {
            unadjusted = parseFloat(unadjusted).toFixed(2);
            unadjusted = parseFloat(unadjusted).toLocaleString("en-US");
            return unadjusted;
        }
        return "$";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between text-gray-700 min-h-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/3 px-[5px]",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/3 px-[5px] text-gray-500",
                children: "$" + unadjustedSalary()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/3 px-[5px] text-gray-500",
                children: "$" + adjustedSalary()
            })
        ]
    });
};
/* harmony default export */ var SalaryCalculator_Category = (Category);

;// CONCATENATED MODULE: ./components/Tools/SalaryCalculator/SalaryCalc.jsx



const SalaryCalc = ()=>{
    const [salaryCategory, setSalaryCategory] = (0,react.useState)({
        hourly: {
            id: 1,
            name: "Hourly",
            unadjusted: "30",
            adjusted: "27.12"
        },
        daily: {
            id: 2,
            name: "Daily",
            unadjusted: "240",
            adjusted: "216.92"
        },
        weekly: {
            id: 3,
            name: "Weekly",
            unadjusted: "1200",
            adjusted: "1085"
        },
        biweekly: {
            id: 4,
            name: "Bi-Weekly",
            unadjusted: "2400",
            adjusted: "2169"
        },
        semimonthly: {
            id: 5,
            name: "Semi-Monthly",
            unadjusted: "2600",
            adjusted: "2350"
        },
        monthly: {
            id: 6,
            name: "Monthly",
            unadjusted: "5200",
            adjusted: "4700"
        },
        quarterly: {
            id: 7,
            name: "Quarterly",
            unadjusted: "15600",
            adjusted: "14100"
        },
        annual: {
            id: 8,
            name: "Annual",
            unadjusted: "62400",
            adjusted: "56400"
        }
    });
    const [salary, setSalary] = (0,react.useState)("30");
    const [payPeriod, setPayPeriod] = (0,react.useState)("hour");
    const [hoursPerWeek, setHoursPerWeek] = (0,react.useState)("40");
    const [daysPerWeek, setDaysPerWeek] = (0,react.useState)("5");
    const [holidaysPerYear, setHolidaysPerYear] = (0,react.useState)("10");
    const [vacationDaysPerYear, setVacationDaysPerYear] = (0,react.useState)("15");
    const calculateSalary = ()=>{
        // Calculate adjusted and unadjusted salaries based on inputs
        let hourlyRate;
        switch(payPeriod){
            case "hour":
                hourlyRate = salary;
                break;
            case "day":
                hourlyRate = salary / (hoursPerWeek / daysPerWeek);
                break;
            case "week":
                hourlyRate = salary / hoursPerWeek;
                break;
            case "biweek":
                hourlyRate = salary / (hoursPerWeek * 2);
                break;
            case "semimonth":
                hourlyRate = salary / (hoursPerWeek * daysPerWeek * 2);
                break;
            case "month":
                hourlyRate = salary / (hoursPerWeek * daysPerWeek * 4);
                break;
            case "quarter":
                hourlyRate = salary / (hoursPerWeek * daysPerWeek * 12);
                break;
            case "Year":
                hourlyRate = salary / (hoursPerWeek * daysPerWeek * 52);
                break;
            default:
                hourlyRate = 0;
                break;
        }
        // calculate unadjusted salary 
        const unadjustedSalary = hourlyRate * (hoursPerWeek / daysPerWeek) * daysPerWeek * 52;
        // Calculate adjusted salary
        let totalDaysAfterVacation = parseInt(holidaysPerYear) + parseInt(vacationDaysPerYear);
        const adjustedSalary = hourlyRate * (hoursPerWeek / daysPerWeek) * (52 * daysPerWeek - totalDaysAfterVacation);
        setSalaryCategory((prevState)=>({
                ...prevState,
                hourly: {
                    ...prevState.hourly,
                    adjusted: adjustedSalary / 52 / hoursPerWeek,
                    unadjusted: hourlyRate
                },
                daily: {
                    ...prevState.daily,
                    adjusted: adjustedSalary / 52 / daysPerWeek,
                    unadjusted: hourlyRate * (hoursPerWeek / daysPerWeek)
                },
                weekly: {
                    ...prevState.weekly,
                    adjusted: adjustedSalary / 52,
                    unadjusted: unadjustedSalary / 52
                },
                biweekly: {
                    ...prevState.biweekly,
                    adjusted: adjustedSalary / 26,
                    unadjusted: unadjustedSalary / 26
                },
                semimonthly: {
                    ...prevState.semimonthly,
                    adjusted: adjustedSalary / 24,
                    unadjusted: unadjustedSalary / 24
                },
                monthly: {
                    ...prevState.monthly,
                    adjusted: adjustedSalary / 12,
                    unadjusted: unadjustedSalary / 12
                },
                quarterly: {
                    ...prevState.quarterly,
                    adjusted: adjustedSalary / 4,
                    unadjusted: unadjustedSalary / 4
                },
                annual: {
                    ...prevState.annual,
                    adjusted: adjustedSalary,
                    unadjusted: unadjustedSalary
                }
            }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full max-w-[1000px] bg-gray-100 mx-auto py-10 md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-gray-500 flex flex-col gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-gray-500 font-medium text-[18px]",
                                children: "Salary Amount"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]",
                                            id: "",
                                            name: "",
                                            type: "text",
                                            placeholder: "",
                                            required: true,
                                            value: salary,
                                            onChange: (e)=>{
                                                setSalary(e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col sm:flex-row items-center",
                                        children: [
                                            "per \xa0\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                className: "border outline-none rounded-md w-[150px] h-[50px]",
                                                id: "",
                                                name: "",
                                                required: true,
                                                value: payPeriod,
                                                onChange: (e)=>{
                                                    setPayPeriod(e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "hour",
                                                        children: "Hour"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "day",
                                                        children: "Day"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "week",
                                                        children: "Week"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "biweek",
                                                        children: "Bi-Week"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "semimonth",
                                                        children: "Semi-Month"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "month",
                                                        children: "Month"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "quarter",
                                                        children: "Quarter"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "year",
                                                        children: "Year"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[18px]",
                                        children: "Hours per Week"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "",
                                        required: true,
                                        value: hoursPerWeek,
                                        onChange: (e)=>{
                                            setHoursPerWeek(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[18px]",
                                        children: "Days per Week"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "",
                                        required: true,
                                        value: daysPerWeek,
                                        onChange: (e)=>{
                                            setDaysPerWeek(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[18px]",
                                        children: "Holidays per year"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "",
                                        required: true,
                                        value: holidaysPerYear,
                                        onChange: (e)=>{
                                            setHolidaysPerYear(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[18px]",
                                        children: "Vacation days per year"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "",
                                        required: true,
                                        value: vacationDaysPerYear,
                                        onChange: (e)=>{
                                            setVacationDaysPerYear(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: calculateSalary,
                                className: "w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl",
                                children: "Calculate"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] lg:w-[50%] h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500",
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between text-gray-700 min-h-[40px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/3 px-[5px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/3 px-[5px]",
                                        children: "Unadjusted"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/3 px-[5px]",
                                        children: "Holidays & Vacation Days Adjusted"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-[1px] bg-gray-400"
                            }),
                            Object.keys(salaryCategory).map((key)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryCalculator_Category, {
                                    name: salaryCategory[key].name,
                                    unadjusted: salaryCategory[key].unadjusted,
                                    adjusted: salaryCategory[key].adjusted
                                }, salaryCategory[key].key);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SalaryCalculator_SalaryCalc = (SalaryCalc);

// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/salary-calculator/index.jsx





const BlogData = [
    {
        id: 1,
        question: "What is a minimum wage in the US, and how does it affect my salary?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Minimum wage is the lowest hourly pay rate that employers can legally pay their employees. The current federal minimum wage in the US is $7.25 per hour, but many states and cities have their own minimum wage rates that are higher than the federal rate. If you earn less than the minimum wage, you may be entitled to file a complaint with the Department of Labor."
            })
        })
    },
    {
        id: 2,
        question: "How can the Salary Calculator help me negotiate a better salary?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "By using the Salary Calculator, you can determine your current pay rate and see how it compares to industry standards and your peers' salaries. Armed with this information, you can confidently negotiate a higher salary with your employer or seek new job opportunities that offer better compensation."
            })
        })
    },
    {
        id: 3,
        question: "Can the Salary Calculator factor in employee benefits such as health insurance and retirement plans?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, our Salary Calculator takes into account employee benefits such as health insurance, retirement plans, and other perks when calculating your total compensation package."
            })
        })
    },
    {
        id: 4,
        question: "Can the Salary Calculator be used by self-employed contractors?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Absolutely. The Salary Calculator can be used by both employees and self-employed contractors to calculate their total income and take-home pay."
            })
        })
    },
    {
        id: 5,
        question: "Can the Salary Calculator calculate daily, weekly, and monthly pay rates?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, the Salary Calculator can convert your salary to daily, weekly, and monthly pay rates, depending on your payment frequency."
            })
        })
    },
    {
        id: 6,
        question: "How accurate is the Salary Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Salary Calculator is designed to provide accurate results based on the latest tax laws and regulations. However, it's important to note that the results are estimates and should be used as a guide only."
            })
        })
    },
    {
        id: 7,
        question: "How do I use the Salary Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "To use the Salary Calculator, simply enter your salary amount and payment frequency. You can also include any employee benefits and adjust for vacation days and holidays. The Salary Calculator will then provide you with accurate salary figures and a breakdown of your total compensation package."
            })
        })
    }
];
const SalaryCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[20px] sm:py-[100px] flex flex-col items-center justify-between gap-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Salary Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/calculators/salary-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/calculators/salary-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Salary Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/calculators/salary-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[15px] sm:gap-[30px] w-full xl:w-[80%] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                        children: "Salary Calculator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white text-[16px] lg:text-[18px] font-light",
                        children: "Maximize your earning potential with our free Salary Calculator tool. Convert your salary and wage amounts to corresponding values based on various payment frequencies, such as biweekly, semi-monthly, or monthly payments. Get accurate, unadjusted figures, and adjusted figures that factor in vacation days and holidays per year. Our Salary Calculator empowers you to make informed financial decisions and optimize your income."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryCalculator_SalaryCalc, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Salary Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var salary_calculator = (SalaryCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(44798); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);